import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(0.5, 0),
  },
}));
